import { dropTodoOnEndOfListSpacer } from '../actions/dropActions';
import getDragToEndOfListDropViewState from '../selectors/getDragToEndOfListDropViewState';
import { observer } from 'mobx-react';
import Droppable from 'owa-dnd/lib/components/Droppable';
import { DragData } from 'owa-dnd/lib/utils/dragDataUtil';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import { TodoItemDragData } from '../store/schema/TodoItemDragData';
import * as React from 'react';

const styles = require('./DragToEndOfList.scss');
const classNames = require('classnames/bind').bind(styles);

@observer
export default class DragToEndOfList extends React.Component<{}, {}> {
    render() {
        const dropViewState = getDragToEndOfListDropViewState();
        const isDragOver = dropViewState.isDragOver;

        return (
            <Droppable canDrop={this.canDrop} onDrop={this.onDrop} dropViewState={dropViewState}>
                <div
                    className={classNames(styles.placeholderItem, {
                        topBorderDragOver: isDragOver,
                    })}
                />
            </Droppable>
        );
    }

    private onDrop(dragData: DragData, pageX: number, pageY: number, target?: HTMLElement) {
        if (dragData.itemType !== DraggableItemTypes.Todo) {
            return;
        }

        const taskDragData = dragData as TodoItemDragData;
        if (taskDragData.ewsItemIds && taskDragData.ewsItemIds.length === 1) {
            dropTodoOnEndOfListSpacer(taskDragData.ewsItemIds[0]);
        }
    }

    private canDrop(dragInfo: DragData): boolean {
        return dragInfo.itemType === DraggableItemTypes.Todo;
    }
}
